import { useContext, useState } from "react"
import Loader from "../Loader";
import SystemModal from "../SystemModal";
import ajaxCallStation from "../../../util/remote/ajaxCallStation";
import SchoolContext from "../../../Context/SchoolContext";
import Select from "react-select";


const CallsFilterForm=(props)=>{

    const [loading, setLoading] = useState(false)
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const {schoolList} = useContext(SchoolContext);
    const [school, setSchool] = useState("");

    const handleSearch = async(e) =>{
        e.preventDefault()
        setLoading(true)
        const server_response = await ajaxCallStation.filterCallStatisticsOverall(startDate, endDate, school);
        setLoading(false);
        if(server_response.status==="OK"){
            props.g(server_response.details, {startDate, endDate})
        }
        else{
            props.g(false)
        } 
    }
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    <button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleSearch}>Filter<i class="fas fa-check mg-l-15"></i></button>
                    </>
        }
    }

    return(
        <SystemModal
            title="Filter Call Statistics"
            id="model-call-filter"
            size="md"
            footer={RenderFooter}
        >

        
            <div className="mb-4 form-group border-1">
                <label htmlFor="">Start Date</label>
                <input  onChange={(e) => setStartDate(e.target.value)}  style={{border: "1px solid grey"}} value={startDate} type="date" className="form-control"/>
            </div>
            <div className="mb-4 form-group border-1">
                <label htmlFor="">End Date</label>
                <input onChange={(e) => setEndDate(e.target.value)}  style={{border: "1px solid grey"}} value={endDate} type="date" className="form-control"/>
            </div>
            <div className="mb-4 form-group border-1">
                <label htmlFor="">School</label>
                <Select
                      onChange={(e) => setSchool(e.school_id)}
                      getOptionLabel={(option) => option.school_name}
                      getOptionValue={(option) => option.school_id}
                      isSearchable
                      options={Array.isArray(schoolList) ? schoolList : []}
                      value={
                        Array.isArray(schoolList) &&
                        schoolList.find((value) => value.school_id === school)
                      }
                    />
            </div>
        
       
        </SystemModal>
    )
}

export default CallsFilterForm
